import { Box, Button } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { useSounds } from 'contexts/Sounds/Sounds';
import { MaterialSymbol } from 'react-material-symbols';
import Image from '../Image/Image';
import { Arrow } from './NextHandButton.styled';

export default function NextHandButton() {
    const game = useGame();
    const sounds = useSounds();

    function handleClick() {
        sounds.play('submit');
        game.reset();
    }

    return (
        <Box position="relative">
            <Button
                className="fill"
                startIcon={<MaterialSymbol aria-hidden icon="payments" size={23} />}
                tabIndex={7}
                variant="text"
                onClick={handleClick}
            >
                Play Another Hand
            </Button>
            {game.hands === 1 && (
                <Arrow>
                    <Image alt="arrow" src="/assets/icons/arrow-orange-curved-down.svg" />
                </Arrow>
            )}
        </Box>
    );
}
